import React, { useState, useEffect, useRef } from 'react';
import { Globe, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const RegionSelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState('Global');
  const dropdownRef = useRef(null);

  const regions = [
    { name: 'Global', flag: '🌍' },
    { name: 'North America', flag: '🇺🇸' },
    { name: 'Europe', flag: '🇪🇺' },
    { name: 'Asia Pacific', flag: '🌏' },
    { name: 'Middle East', flag: '🇦🇪' },
    { name: 'Latin America', flag: '🇧🇷' },
    { name: 'Africa', flag: '🌍' }
  ];

  const handleRegionSelect = (region) => {
    setSelectedRegion(region.name);
    setIsOpen(false);
    // Here you would typically handle region-specific content loading
    console.log(`Selected region: ${region.name}`);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="region-selector" ref={dropdownRef}>
      <button 
        className="region-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Globe size={16} />
        <span>{selectedRegion}</span>
        <ChevronDown size={14} className={`chevron ${isOpen ? 'open' : ''}`} />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="region-dropdown"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
          >
            {regions.map((region) => (
              <button
                key={region.name}
                className={`region-option ${selectedRegion === region.name ? 'selected' : ''}`}
                onClick={() => handleRegionSelect(region)}
              >
                <span className="region-flag">{region.flag}</span>
                <span>{region.name}</span>
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default RegionSelector;